import React, { useContext, useEffect, useState } from 'react';
import { useDrop } from 'react-dnd';
import "./UserRow.scss";
import { useRef } from 'react';
import { AuthContext } from '../../context/AuthContext';

const UserRow = ({children, handleDrop, time, user, stage, allowDrop }) => {
  const dropRef = useRef(null);

  
  const [{isOver}, drop] = useDrop(() => ({
    accept: 'task',
    drop: (item) => {
      const clonedTask = { 
        ...item.task,
        startTime:time.time,
        timeId:time.id,
        duration:1,
        user:{id:user._id},
        stage:stage,
      
      };
      handleDrop(clonedTask);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
    canDrop: (item) => {
      return allowDrop; // Allow drop only if the task does not exist
    }
  }));

  return (
    <div 
      className={isOver?'hovered dropArea':'dropArea'} 
      ref={(node) => {
        drop(node);
        dropRef.current = node;
      }}
    >
        {children}
    </div>
  );
};

export default UserRow;